export default "__VITE_ASSET__1217e961__"